import type { ThemeConfig } from "../../types";

export const classicTheme: ThemeConfig = {
  weak: { color: "#ff4d4d", label: "Weak" },
  fair: { color: "#ffaa00", label: "Fair" },
  good: { color: "#2196f3", label: "Good" },
  strong: { color: "#4caf50", label: "Strong" },
};
